module.exports = __webpack_public_path__ + "static/media/pic1.0889c917.jpg";